<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <b-row align-v="center">
                <b-col>
                    <legend>General Settings</legend>
                </b-col>
                <b-col cols="auto" class="d-flex align-items-center">
                    <b-button type="button" @click="getSettings" pill variant="outline-dark">
                        Refresh
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6">
                    <b-card>
                        <div v-if="!settings.length" class="text-muted">No settings found.</div>

                        <div v-for="row in settings" :key="row.key" class="mb-3">
                            <b-form-checkbox v-if="row.isBoolean" v-model="row.boolValue" @change="onToggle(row, $event)" switch>
                                {{ row.key }}
                            </b-form-checkbox>
                            <b-form-group v-else :label="row.key" :label-for="row.key">
                                <b-form-input :id="row.key" v-model="row.value"></b-form-input>
                            </b-form-group>
                        </div>

                        <b-button type="button" @click="save" variant="outline-success" :disabled="saving || !settings.length">
                            Save
                        </b-button>
                    </b-card>
                </b-col>
            </b-row>

            <loading :active.sync="isLoading" :is-full-page="true"></loading>
        </div>
    </main>
</div>
